/* file: src/components/modals/PhaseInfoModal */

import React from 'react';
import { Info, X } from 'lucide-react';
import styles from './PhaseInfoModal.module.css';

const PHASE_DESCRIPTIONS = {
  'Concept Exploration': 'This phase involves identifying the problem space and evaluating potential solutions. Engineers perform feasibility studies, cost-benefit analyses, and trade-offs to define the best concept for development.',
  'Requirements': 'This phase focuses on defining the system\'s objectives, constraints, and specifications and translating them into actionable technical requirements for subsequent design and development.',
  'Architecture': 'This phase serves as a blueprint for detailed design. The overall system structure is designed. Outline high-level components, their interactions, and interfaces to ensure the system aligns with requirements.',
  'Detailed Design': 'This phase dives into specifics, creating detailed schematics, PCB layouts, firmware designs, and mechanical drawings. Engineers finalize "build-to" specifications that will be used for manufacturing and assembly',
  'Integration & Testing': 'In this phase, individual components are assembled into subsystems and then into the complete system. Engineers verify that all components work together as intended and validate that the system meets its original requirements through rigorous testing',
  'Manufacturing': 'This phase includes fabricating PCBs, assembling hardware, and ensuring production processes meet quality standards for mass production',
  'Operations & Maintenance': 'After deployment, this phase ensures the system operates effectively in its intended environment. It involves monitoring performance, addressing issues, implementing updates, and supporting users to extend the system\'s lifecycle'
};

// Modal Component
export default function PhaseInfoModal({ phaseName, onClose }) {
  if (!phaseName) return null;

  const description = PHASE_DESCRIPTIONS[phaseName] || 'Description not available.';

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.headerIcon}>
              <Info className="h-4 w-4" />
            </div>
            <h2 className={styles.headerTitle}>{phaseName}</h2>
          </div>
          <p className={styles.description}>
            {description}
          </p>
        </div>

        <div className={styles.footer}>
          <button
            type="button"
            onClick={onClose}
            className={styles.closeButton}
          >
            <X className="h-4 w-4 mr-2" />
            Close
          </button>
        </div>
      </div>
    </div>
  );
} 